import { render, staticRenderFns } from "./bind.vue?vue&type=template&id=5a06aa3a&scoped=true&"
import script from "./bind.vue?vue&type=script&lang=js&"
export * from "./bind.vue?vue&type=script&lang=js&"
import style0 from "./bind.vue?vue&type=style&index=0&id=5a06aa3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a06aa3a",
  null
  
)

export default component.exports